const colors = {
  palette: {
    'blue-banner': '#122656',
    'blue-text': '#002033',
    'blue-title': '#00629B',
    grey: '#797A7C',
    'grey-lightest': '#F7F7F7',
    'grey-mid': '#E5E5E5',
    'white-off': '#F7F8FA',
  },
  system: {
    black: '#000000',
    danger: '#D32F2f',
    link: '#00629B',
    'link-disabled': '#7CADCA',
    success: '#6BA33E',
    warning: '#E46F1F',
    white: '#FFFFFF',
  },
  light: {
    primary: '#00629B',
  },
};

export default colors;
